import CrudRepository from './CrudRepository'
export default class ProductsCategories extends CrudRepository {
  constructor (type) {
    super(`customerCare/api/serviceManagement/type/${type}`)
  }
}
